import { type CarrierInfo, isObject, useApiPostDealTrackerV1CarriersRetrieve } from 'api';
import { useState } from 'react';

import {
  MultiAutocompleteField,
  type MultiAutocompleteFieldProps,
} from '../MultiAutocompleteField/MultiAutocompleteField';

type Props = Omit<MultiAutocompleteFieldProps<CarrierInfo>, 'options' | 'isOptionEqualToValue' | 'getOptionLabel'>;
export const MultiCarrierAutocompleteField = (props: Props) => {
  const [query, setQuery] = useState('');

  const { data, isLoading } = useApiPostDealTrackerV1CarriersRetrieve({
    page_size: 100000,
    search: query, // Large page size to get all carriers
  });

  return (
    <MultiAutocompleteField<CarrierInfo>
      options={data?.results || []}
      loading={isLoading}
      {...props}
      getOptionLabel={(option) => {
        if (isObject(option) && option?.name) {
          return option.name;
        }
        return '';
      }}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
    />
  );
};
